<app-time-off-request-modal
    title="Floater Day Request"
    [visible]="visible"
    (visibleChange)="visible = $event; visibleChange.emit($event)"
    [isScreenSmall]="!!(screen.xSmallScreenChanged | async)"
    [height]="'auto'"
    [canEdit]="canEdit"
    [canApprove]="canApprove"
    [canDecline]="canDecline"
    [canWithdrawn]="canWithdrawn"
    (save)="onSave()"
    (close)="close()"
    (statusChange)="changeStatus($event)"
    [timeOffRequest]="request"
>
    @if(formData){
        <dx-form>
            <dxi-item>
                <label class="form-label">Employee*</label>
                <pictured-item-select-box
                    [value]="formData.employee.id"
                    (valueChange)="onEmployeeChange($event)"
                    [dataSource]="employeesDataSource"
                    [readOnly]="!canEditEmployee"
                ></pictured-item-select-box>
            </dxi-item>
            <dxi-item>
                <dx-date-range-box
                    stylingMode="filled"
                    [(startDate)]="formData.requestedStartDate"
                    [(endDate)]="formData.requestedEndDate"
                    (startDateChange)="onStartDateChange($event)"
                    (endDateChange)="onEndDateChange($event)"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-range-box>
            </dxi-item>
            <dxi-item>
                <strong>Floater Day(s) Requested:</strong>
                @if (formData.workingDays) {
                    {{ formData.workingDays }}
                } @else {
                    {{ daysRequested | async }}
                }
            </dxi-item>
            <dxi-item>
                <strong>Floater Day(s) Available:</strong> {{ (employeeBalance | async).floaterDaysAvailable }}
            </dxi-item>
            <dxi-item>
                <dx-text-area
                    label="Description*"
                    stylingMode="filled"
                    [height]="70"
                    [(value)]="formData.description"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>
            </dxi-item>
        </dx-form>
    }

</app-time-off-request-modal>
